<template>
  <div class="mt-4">
    <div class="row">
      <div class="col-6">
        <h3>Select indication &#38; stage</h3>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-5 col-sm-6 col-12 mb-4">
        <app-disease-tree-selector
          :branchId.sync="branchId"
          class=""
          :only-answered="true"
        />
      </div>
    </div>

    <div class="row" v-if="branchId">
      <!--2D Matrix -->
      <div class="col mb-4">
        <h5>Compound Rating</h5>
        <app-scatter-chart
            v-if="ratingCollection && ratingCollection.getPoints().length"
            :pointsCollection="ratingCollection"
            :xAxisLabel="efficacyLabel"
            :yAxisLabel="safetyLabel"
            :allow-drag-all="true"
            @pointCoordsChanged="pointCoordsChangedHandler"
        />
      </div>
      <!--//2D Matrix -->
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-property-decorator";
import { HttpHandler } from "@/http/HttpHandler";
import { ToolOpinionModel } from "@/entities/ToolOpinionModel";
import AppCompoundRating from "@/components/expert/AppCompoundRating.vue";
import AppScatterChart from "@/components/expert/AppScatterChart.vue";
import { PointsCollection } from "@/entities/chart/PointsCollection";
import { Point } from "@/entities/chart/Point";
import AppDiseaseTreeSelector from "@/components/AppDiseaseTreeSelector.vue";
import AppGroup from "@/components/expert/AppGroup.vue";
import AppToolSelector from "@/components/AppToolSelector.vue";
import store from "@/store/index";

@Component({
  components: {
    AppDiseaseTreeSelector,
    AppGroup,
    AppToolSelector,
    AppCompoundRating,
    AppScatterChart
  }
})
export default class Ratings extends Vue {
  private ratings: ToolOpinionModel[] = [];
  private branchId: number | null = null;
  @Watch("branchId")
  async onBranchChanged(newBranchId: number) {
    await this.getRatings(newBranchId);
    await this.replaceQueryParams();
  }

  async getRatings(branchId: number) {
    let httpHandler = new HttpHandler(store);
    this.ratings = [];
    this.ratings = await httpHandler.getRatings(branchId);
  }

  get ratingCollection(): PointsCollection {
    if (this.ratings.length === 0) {
      return new PointsCollection();
    }

    const points = this.ratings.map(
      x =>
        new Point(x.tool.id, x.efficacy, x.safety, x.tool.name, x.uniqueColor)
    );

    return new PointsCollection(points);
  }

  async saveRating(pointId: number, efficacy: number, safety: number) {
    let httpHandler = new HttpHandler(store);
    let point = this.ratings.find(p => p.tool.id == pointId);
    const pointWasModified =
      !!point && (point.safety !== safety || point.efficacy !== efficacy);
    console.log(point);
    if (pointWasModified) {
      await httpHandler
        .setRating(this.branchId, {
          id: pointId,
          efficacy: efficacy,
          safety: safety
        })
        .then(() => {
          if (point !== undefined) {
            point.safety = safety;
            point.efficacy = efficacy;
            this.$notify({
              group: "main",
              title: "Data Saved",
              text: "Rating successfully saved"
            });
          }
        });
    }
  }

  created() {
    const hasBranchIdParam: boolean =
      !!this.$route.query.branchId &&
      !isNaN(Number(this.$route.query.branchId));

    if (hasBranchIdParam) {
      this.branchId = Number(this.$route.query.branchId);
    }
  }

  pointCoordsChangedHandler(pointId: number, coords: [number, number]) {
    const efficacy = coords[0];
    const safety = coords[1];

    this.saveRating(pointId, efficacy, safety);
  }

  async replaceQueryParams(): Promise<void> {
    const branchIdEquals = Number(this.$route.query.branchId) === this.branchId;

    if (branchIdEquals) return;
    const query = {
      branchId: this.branchId ? this.branchId.toString() : ""
    };

    await this.$router.replace({ name: "Ratings", query: query });
  }

  get efficacyLabel(): string {
    return "Efficacy";
  }

  get safetyLabel(): string {
    return "Safety";
  }
}
</script>

<style scoped></style>
